import template from './appVersionLabel.html';
import controller from './appVersionLabel.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
  },
};

export default component;
